
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const skuApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listSKUs: builder.query ({
      query: (params) => `v2/sku/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["SKU"]
    }),
    getSKU: builder.query ({
      query: (sku_id) => `v2/sku/${sku_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["SKU"]
    }),
    getSKUIn_stores: builder.query ({
      query: (sku_id) => `v2/storesku/?SKU=${sku_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["StoreSKU"]
    }),
    getSKUMetadata: builder.query ({
      query: (sku_id) => `v2/skumetadata/?SKU=${sku_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUMetadata"]
    }),
    getSKUGroup_items: builder.query ({
      query: (sku_id) => `v2/skugroup/?parent=${sku_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUGroup"]
    }),
    getSKUImages: builder.query ({
      query: (sku_id) => `v2/skuimage/?SKU=${sku_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUImage"]
    }),
    updateSKU: builder.mutation ({
      query: ({sku_id, data}) => ({
        url: `v2/sku/${sku_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["SKU"]
    }),
    deleteSKU: builder.mutation ({
      query: (sku_id) => ({
        url: `v2/sku/${sku_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["SKU"]
    }),
    createSKU: builder.mutation ({
      query: (data) => ({
        url: `v2/sku/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["SKU"]
    }),
  })
})


export const {
  useListSKUsQuery,
  useLazyListSKUsQuery,
  useGetSKUQuery,
  useLazyGetSKUQuery,
  useGetSKUIn_storesQuery,
  useGetSKUMetadataQuery,
  useGetSKUGroup_itemsQuery,
  useGetSKUImagesQuery,
  useUpdateSKUMutation,
  useDeleteSKUMutation,
  useCreateSKUMutation
} = skuApi
